import {
  COMPONENT_TYPE,
  checkIfNodeComplete,
  NOTEBOOK_SECTIONS,
} from '@learningblocks/protocol-constants/lib/Utilities';
// update notebook sections array and set current session as current.
export function setSectionSelected(sections, currentSectionName) {
  return sections.map((section) => {
    if (section.value === currentSectionName) {
      section.current = true;
    } else {
      section.current = false;
    }
    return section;
  });
}

// set currentSession key with data for selected NotebookSection
export function setCurrentSection(levelData, currentSectionName) {
  if (currentSectionName === NOTEBOOK_SECTIONS.PROTOCOL) {
    return updateSectionComponents(levelData.PROTOCOL_CHAPTER);
  } else {
    return updateSectionComponents(levelData.GENERIC_CHAPTERS[currentSectionName]);
  }
}

//function that adds extra keys required to process various question Components:
export function updateSectionComponents(currentSection) {
  return {
    ...currentSection,
    components: currentSection.components.map(updateCurrentSectionComponent),
  };
}

function updateCurrentSectionComponent(component) {
  let updatedComponent = {...component};
  switch (updatedComponent.type) {
    case COMPONENT_TYPE.DDQ:
      updatedComponent.answerSteps = updatedComponent.answerSteps.map(
        updateDDQStepOption
      );
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.DNDQ_COLOR:
      updatedComponent.sliders = updatedComponent.sliders.map(
        updateDNDQSliders
      );
      updatedComponent = updateDNDQComponentKeys(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.CSCQ:
    case COMPONENT_TYPE.CSCQ_COLOR:
      updatedComponent = updateCSCQComponentOptions(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.GROUPED_CSCQ:
      updatedComponent = updateGroupedCSCQComponentOptions(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.OEQ:
      updatedComponent = updateOEQComponentOptions(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.NEQ:
      updatedComponent = updateNEQComponentOptions(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.MSCQ:
      updatedComponent = updateMSCQCheckboxes(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    case COMPONENT_TYPE.GROUPED_DNDQ:
      updatedComponent.sliderGroups = updatedComponent.sliderGroups.map(
        updateDNDQSliderGroup
      );
      updatedComponent = updateDNDQComponentKeys(updatedComponent);
      updatedComponent = updateCommonQuestionComponentKeys(updatedComponent);
      break;
    default:
      break;
  }
  return updatedComponent;
}

// Add complete key, the key is used to detect question completion.
function updateCommonQuestionComponentKeys(component) {
  let updated = {};
  if (component.hasOwnProperty('complete')) {
    updated = {...component};
  } else {
    updated = {...component, complete: false};
  }
  return updated;
}

// Function to update keys for CSCQ
function updateCSCQOption(option) {
  let updatedOption = {};
  if (option.hasOwnProperty('selected')) {
    updatedOption = {...option};
  } else {
    updatedOption = {...option, selected: false, disabled: false};
  }
  return updatedOption;
}

// Function to update keys for DDQ
function updateDDQStepOption(option) {
  let updatedStepOption = {};
  if (option.hasOwnProperty('droppedId')) {
    updatedStepOption = {...option};
  } else {
    updatedStepOption = {...option, droppedId: null, showFeedback: false};
  }
  return updatedStepOption;
}

// Function to update keys for DNDQSlider
function updateDNDQSliders(slider) {
  let updatedSlider = {...slider, updated: false};
  return updatedSlider;
}

// Function to update keys for DNDQSliderGroup
function updateDNDQSliderGroup(sliderGroup) {
  let updatedSliderGroup = {...sliderGroup, updated: false};
  return updatedSliderGroup;
}

function updateDNDQComponentKeys(component) {
  if (component.hasOwnProperty('showFeedback')) {
    return component;
  } else {
    return {...component, showFeedback: false};
  }
}

// Function to update CSCQ/CSCQColor options
function updateCSCQComponentOptions(component) {
  if (component.hasOwnProperty('typedOptions')) {
    component.typedOptions = component.typedOptions.map(updateCSCQOption);
  }
  if (component.hasOwnProperty('options')) {
    component.options = component.options.map(updateCSCQOption);
  }
  return component;
}

// Function to update GROUPED CSCQ options
function updateGroupedCSCQComponentOptions(component) {
  if (component.hasOwnProperty('groupedOptions1')) {
    component.groupedOptions1 = component.groupedOptions1.map(updateCSCQOption);
  }
  if (component.hasOwnProperty('groupedOptions2')) {
    component.groupedOptions2 = component.groupedOptions2.map(updateCSCQOption);
  }
  return component;
}

// Function to update single MSCQ checkbox
function updateCheckbox(checkbox) {
  if (checkbox.hasOwnProperty('selected')) {
    return {...checkbox};
  } else {
    return {...checkbox, selected: false, disabled: false};
  }
}

// Function to update OEQ response area
function updateOEQComponentOptions(component) {
  if(!component.hasOwnProperty('responseArea')){
    component.responseArea = null;
  }
  if(!component.hasOwnProperty('savedResponse')){
    component.savedResponse = null;
  }

  return component;
}

// Function to update NEQ numeric entry
function updateNEQComponentOptions(component) {
  if(!component.hasOwnProperty('numericEntry')){
    component.numericEntry = null;
  }
  if(!component.hasOwnProperty('savedEntry')){
    component.savedEntry = null;
  }

  return component;
}

// Function to update MSCQ checkboxed
function updateMSCQCheckboxes(component) {
  component.checkboxes = component.checkboxes.map(updateCheckbox);
  return component;
}

// to updateNumber of Incorrects for DragAndDrop
export function updateIncorrectsDragDrop(incorrects, payload) {
  if (payload.componentID === payload.positionID) {
    return incorrects;
  } else {
    return incorrects + 1;
  }
}

// to substitute a particular slide in desingSection.allSlides list
export function updateSlideInList(allSlides, designSlide) {
  return allSlides.map((slide) => {
    if (slide.type === designSlide.type) {
      return {...designSlide};
    } else {
      return {...slide};
    }
  });
}

// function to set current node for DesignSlideTwo
export function setNewCurrentNode(slideTree) {
  let isCurrentNodeSet = null;
  return slideTree.map((nodeGroup) => {
    const groupNodes = nodeGroup.groupNodes.map((nodeItem) => {
      const nodeComplete = checkIfNodeComplete(nodeItem);
      if (isCurrentNodeSet === null && nodeComplete) {
        isCurrentNodeSet = false;
        nodeItem = {...nodeItem, current: false};
      } else if (isCurrentNodeSet === false && nodeComplete === false) {
        nodeItem = {...nodeItem, current: true};
        isCurrentNodeSet = true;
      } else {
        nodeItem = {...nodeItem, current: false};
      }
      return nodeItem;
    });
    return {...nodeGroup, groupNodes};
  });
}

// function to set droppedId in designSlideThree
export function updateInSlideThree(slide, params) {
  const updateIncorrects = () => {
    if (params.nodeId === params.optionId) {
      return slide.incorrects;
    } else {
      return slide.incorrects + 1;
    }
  };

  const updateInNode = (node) => {
    if (node.nodeId === params.nodeId) {
      node.droppedId = params.optionId;
      if (node.nodeId !== params.optionId) {
        node.wrongAttempts = node.wrongAttempts + 1;
      }
    }
    return node;
  };

  const updateInGroup = (group) => {
    if (group.groupId === params.groupId) {
      group.groupNodes = group.groupNodes.map(updateInNode);
    }
    return group;
  };

  return {
    ...slide,
    incorrects: updateIncorrects(),
    slideTree: slide.slideTree.map(updateInGroup),
  };
}
